import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { canAddToCart } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { useContext } from "react";
import { useSelector } from "react-redux";

const useCanAddToCart = (product?: ProductModel) => {
    const _product = product || useContext(ProductContext)?.product;

    return useSelector((state: ApplicationState) => {
        return _product ? canAddToCart(state, _product) : false;
    });
};

export default useCanAddToCart;
